export const PREMIUM_UNLOCK_REDIRECT = 'ads.premium.unlock.redirect';
export const PREMIUM_UNLOCK_CLICK_ERROR = 'ads.premium.unlock.click.error';

export const MINT_ERROR = 'ads.mint.error';
export const MINT_INFO = 'ads.mint.info';
